module.exports = __webpack_public_path__ + "static/media/filesImage.ceece0ee.png";